import useLanguage from "@src/features/contentDetail/hooks/useLanguage";
import { useTranslation } from "@src/features/contentDetail/utils/translationSets";
import { useMemo } from "react";

export const HOW_DID_I_DO_ENGLISH = "How did I do?";
export const GREAT_TELL_ME_WHAT_YOU_LIKED_ENGLISH =
  "Great! Tell me what you liked.";
export const HELP_ME_IMPROVE_ENGLISH =
  "Help me improve. What could I do better?";
export const TELL_ME_WHAT_YOU_LIKED_ENGLISH = "liked";
export const TELL_ME_WHAT_I_COULD_IMPROVE_ENGLISH = "think I could improve";
export const SUBMITTING_ENGLISH = "Submitting...";
export const SUBMIT_FEEDBACK_ENGLISH = "Submit Feedback";
export const PLACEHOLDER_POSITIVE_FEEDBACK_ENGLISH = "I liked...";
export const PLACEHOLDER_NEGATIVE_FEEDBACK_ENGLISH = "To improve...";

type Return = {
  howDidIDo: string;
  greatTellMeWhatYouLiked: string;
  helpMeImprove: string;
  tellMeWhatYouLiked: string;
  tellMeWhatICouldImprove: string;
  submitting: string;
  submitFeedback: string;
  placeholderPositiveFeedback: string;
  placeholderNegativeFeedback: string;
};

export const useAIFeedbackTranslations = (): Return => {
  const language = useLanguage();

  const howDidIDoTranslation = useTranslation(HOW_DID_I_DO_ENGLISH, language);
  const greatTellMeWhatYouLikedTranslation = useTranslation(
    GREAT_TELL_ME_WHAT_YOU_LIKED_ENGLISH,
    language,
  );
  const helpMeImproveTranslation = useTranslation(
    HELP_ME_IMPROVE_ENGLISH,
    language,
  );
  const tellMeWhatYouLikedTranslation = useTranslation(
    TELL_ME_WHAT_YOU_LIKED_ENGLISH,
    language,
  );
  const tellMeWhatICouldImproveTranslation = useTranslation(
    TELL_ME_WHAT_I_COULD_IMPROVE_ENGLISH,
    language,
  );
  const submittingTranslation = useTranslation(SUBMITTING_ENGLISH, language);
  const submitFeedbackTranslation = useTranslation(
    SUBMIT_FEEDBACK_ENGLISH,
    language,
  );
  const placeholderPositiveFeedbackTranslation = useTranslation(
    PLACEHOLDER_POSITIVE_FEEDBACK_ENGLISH,
    language,
  );
  const placeholderNegativeFeedbackTranslation = useTranslation(
    PLACEHOLDER_NEGATIVE_FEEDBACK_ENGLISH,
    language,
  );

  return useMemo(
    () => ({
      howDidIDo: howDidIDoTranslation.text || HOW_DID_I_DO_ENGLISH,
      greatTellMeWhatYouLiked:
        greatTellMeWhatYouLikedTranslation.text ||
        GREAT_TELL_ME_WHAT_YOU_LIKED_ENGLISH,
      helpMeImprove: helpMeImproveTranslation.text || HELP_ME_IMPROVE_ENGLISH,
      tellMeWhatYouLiked:
        tellMeWhatYouLikedTranslation.text || TELL_ME_WHAT_YOU_LIKED_ENGLISH,
      tellMeWhatICouldImprove:
        tellMeWhatICouldImproveTranslation.text ||
        TELL_ME_WHAT_I_COULD_IMPROVE_ENGLISH,
      submitting: submittingTranslation.text || SUBMITTING_ENGLISH,
      submitFeedback: submitFeedbackTranslation.text || SUBMIT_FEEDBACK_ENGLISH,
      placeholderPositiveFeedback:
        placeholderPositiveFeedbackTranslation.text ||
        PLACEHOLDER_POSITIVE_FEEDBACK_ENGLISH,
      placeholderNegativeFeedback:
        placeholderNegativeFeedbackTranslation.text ||
        PLACEHOLDER_NEGATIVE_FEEDBACK_ENGLISH,
    }),
    [
      howDidIDoTranslation.text,
      greatTellMeWhatYouLikedTranslation.text,
      helpMeImproveTranslation.text,
      tellMeWhatYouLikedTranslation.text,
      tellMeWhatICouldImproveTranslation.text,
      submittingTranslation.text,
      submitFeedbackTranslation.text,
      placeholderPositiveFeedbackTranslation.text,
      placeholderNegativeFeedbackTranslation.text,
    ],
  );
};
